import { FC, ReactElement } from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { tokens } from "@/tokens";

const PlaceholderCard: FC<IPlaceholderCard> = ({
  title,
  description,
  imgUrl,
  isBordered,
  centerContent,
  cardStyles = {},
}): ReactElement => {
  return (
    <Card
      sx={{
        p: 3.5,
        height: "100%",
        ...cardStyles,
        ...(centerContent && {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }),
        ...(isBordered && {
          boxShadow: 0,
          border: `1px solid ${tokens.border.default}`,
        }),
      }}
    >
      <Stack alignItems="center">
        <Box
          component="img"
          width="180px"
          height="180px"
          {...(!centerContent ? { pt: 3 } : {})}
          pb={1}
          src={imgUrl}
          alt="data placeholder image"
        />
        {title && (
          <Typography
            variant="body1"
            textAlign="center"
            fontSize={20}
            fontWeight={tokens.fontWeight.semibold}
            color={tokens.text.primary}
            mb={1.25}
          >
            {title}
          </Typography>
        )}
        <Typography
          variant="body2"
          textAlign="center"
          fontWeight={tokens.fontWeight.normal}
          sx={{ color: tokens.text.secondary }}
          maxWidth={370}
        >
          {description}
        </Typography>
      </Stack>
    </Card>
  );
};

export default PlaceholderCard;
